/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetProfileCategoryDto } from './GetProfileCategoryDto';
import {
    GetProfileCategoryDtoFromJSON,
    GetProfileCategoryDtoFromJSONTyped,
    GetProfileCategoryDtoToJSON,
} from './GetProfileCategoryDto';

/**
 * 
 * @export
 * @interface GetProfileCategoryYearDto
 */
export interface GetProfileCategoryYearDto {
    /**
     * 
     * @type {string}
     * @memberof GetProfileCategoryYearDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetProfileCategoryYearDto
     */
    year: number;
    /**
     * 
     * @type {string}
     * @memberof GetProfileCategoryYearDto
     */
    purchasesFinancialAccount: string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileCategoryYearDto
     */
    salesFinancialAccount: string;
    /**
     * 
     * @type {string}
     * @memberof GetProfileCategoryYearDto
     */
    commissionFinancialAccount: string;
    /**
     * 
     * @type {GetProfileCategoryDto}
     * @memberof GetProfileCategoryYearDto
     */
    profileCategory: GetProfileCategoryDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetProfileCategoryYearDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetProfileCategoryYearDto
     */
    internal?: boolean;
}

/**
 * Check if a given object implements the GetProfileCategoryYearDto interface.
 */
export function instanceOfGetProfileCategoryYearDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "year" in value;
    isInstance = isInstance && "purchasesFinancialAccount" in value;
    isInstance = isInstance && "salesFinancialAccount" in value;
    isInstance = isInstance && "commissionFinancialAccount" in value;
    isInstance = isInstance && "profileCategory" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetProfileCategoryYearDtoFromJSON(json: any): GetProfileCategoryYearDto {
    return GetProfileCategoryYearDtoFromJSONTyped(json, false);
}

export function GetProfileCategoryYearDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProfileCategoryYearDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'year': json['year'],
        'purchasesFinancialAccount': json['purchasesFinancialAccount'],
        'salesFinancialAccount': json['salesFinancialAccount'],
        'commissionFinancialAccount': json['commissionFinancialAccount'],
        'profileCategory': GetProfileCategoryDtoFromJSON(json['profileCategory']),
        'active': json['active'],
        'internal': !exists(json, 'internal') ? undefined : json['internal'],
    };
}

export function GetProfileCategoryYearDtoToJSON(value?: GetProfileCategoryYearDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'year': value.year,
        'purchasesFinancialAccount': value.purchasesFinancialAccount,
        'salesFinancialAccount': value.salesFinancialAccount,
        'commissionFinancialAccount': value.commissionFinancialAccount,
        'profileCategory': GetProfileCategoryDtoToJSON(value.profileCategory),
        'active': value.active,
        'internal': value.internal,
    };
}

